import type { ComponentProps } from 'react';

import { clsxm } from '@vs-shop/utils';

export const IconAuthor = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg
    data-slot="icon-author"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 13 14"
    fill="none"
    className={clsxm('h-3.5 w-[13px]', className)}
    {...props}
  >
    <path
      d="M1.97363 13.2441C1.59082 13.2441 1.29004 13.1576 1.07129 12.9844C0.852539 12.8112 0.743164 12.5742 0.743164 12.2734C0.743164 11.8314 0.875326 11.3688 1.13965 10.8857C1.40853 10.4027 1.79362 9.94922 2.29492 9.52539C2.80078 9.10156 3.40918 8.75749 4.12012 8.49316C4.83105 8.22884 5.62858 8.09668 6.5127 8.09668C7.40137 8.09668 8.20117 8.22884 8.91211 8.49316C9.62305 8.75749 10.2292 9.10156 10.7305 9.52539C11.2363 9.94922 11.6237 10.4027 11.8926 10.8857C12.1615 11.3688 12.2959 11.8314 12.2959 12.2734C12.2959 12.5742 12.1865 12.8112 11.9678 12.9844C11.749 13.1576 11.4482 13.2441 11.0654 13.2441H1.97363ZM6.51953 6.87988C6.02279 6.87988 5.56478 6.74544 5.14551 6.47656C4.73079 6.20768 4.39583 5.84538 4.14062 5.38965C3.88997 4.93392 3.76465 4.4235 3.76465 3.8584C3.76465 3.30241 3.88997 2.80111 4.14062 2.35449C4.39583 1.90332 4.73307 1.54557 5.15234 1.28125C5.57161 1.01693 6.02734 0.884766 6.51953 0.884766C7.01628 0.884766 7.47428 1.01465 7.89355 1.27441C8.31283 1.53418 8.64779 1.88965 8.89844 2.34082C9.15365 2.78743 9.28125 3.28874 9.28125 3.84473C9.28125 4.41439 9.15365 4.92936 8.89844 5.38965C8.64779 5.84538 8.31283 6.20768 7.89355 6.47656C7.47428 6.74544 7.01628 6.87988 6.51953 6.87988Z"
      fill="currentColor"
    />
  </svg>
);
